module.exports = __webpack_public_path__ + "static/media/noHardware.55aec440.png";